import Component from "../../lib/component";
import {isScrollable} from "../../helpers/scrolling";
import {getThrottledFunction} from "../../helpers/throttle";
import {ReviewTextWrap} from "./review_text_wrap";
import {extractEmoji} from "../../helpers/emoji";
import {AvatarConfig} from "../avatar/avatar";
import {getElementComponentsOfType} from "../../lib/global_components";

export const ReviewItemConfig = {
    baseHtmlClass: 'review__item',
    selector: '.review__item',

    datasetConfigKey: 'review__item__config',
    itemTypeDatasetConfigKey: 'item_type',

    rankingItemTypeCode: 'ranking',
    replyItemTypeCode: 'reply',

    messageSelector: '.review__msg',
    personSelector: '.review__person',
    avatarSelector: '.review__person__avatar .avatar',
    textWrapSelector: '.review__msg__text_wrap',

    scrollableClassModifier: 'scrollable',
    hasScrolledClassModifier: 'scrolled',

    hasScrolledDefaultThreshold: 10,
};

export class ReviewItem extends Component {

    constructor(id_or_element, review) {
        super({
            element: id_or_element,
            config: ReviewItemConfig
        });

        this.review = review;

        this.setDatasetConfig(ReviewItemConfig.datasetConfigKey);
        this.itemType = this.getDatasetConfigValue(ReviewItemConfig.itemTypeDatasetConfigKey);

        this.isScrolled = false;

        this.messageElement = this.element.querySelector(ReviewItemConfig.messageSelector);
        this.personElement = this.element.querySelector(ReviewItemConfig.personSelector);

        this.textWrapElement = this.element.querySelector(ReviewItemConfig.textWrapSelector);
        if (this.textWrapElement) this.textWrap = new ReviewTextWrap(this.textWrapElement, this.personElement, review);

        this.avatarElement = this.element.querySelector(ReviewItemConfig.avatarSelector);

        this.emoji = this.extractEmoji();
        if (this.emoji && this.emoji.length > 0) {
            // HACK - Wait for all the avatar components to be constructed.
            setTimeout(() => {
                this.avatarComponent = this.getAvatarComponent();
                if (this.avatarComponent) this.avatarComponent.setEmoji(this.emoji);
            }, 1000)
        }

        this.scrolledThreshold = this.getScrolledThreshold();
        const scrollHandler = getThrottledFunction(this.handleScroll.bind(this), 10);
        this.messageElement.addEventListener('scroll', scrollHandler.bind(this));
    }

    handleScroll(event) {
        this.review.render();
    }

    hasScrolledDown() {
        return this.messageElement.scrollTop >= this.scrolledThreshold;
    }

    isScrollable() {
        return !!isScrollable(this.messageElement);
    }

    render() {
        this.conditionallySetHtmlClassState(this.isScrollable(), ReviewItemConfig.scrollableClassModifier);
        this.conditionallySetHtmlClassState(this.hasScrolledDown(), ReviewItemConfig.hasScrolledClassModifier);
        if (this.textWrap) this.textWrap.render();
    }

    getScrolledThreshold() {
        return ReviewItemConfig.hasScrolledDefaultThreshold;
    }

    extractEmoji() {
        if (!this.messageElement) return [];
        return extractEmoji(this.messageElement.textContent);
    }

    getAvatarComponent() {
        let avatarComponents = (!!this.avatarElement) ? getElementComponentsOfType(this.avatarElement, AvatarConfig.componentTypeKey) : [];
        return (avatarComponents.length > 0) ? avatarComponents[0] : null;
    }

}
